import { useToaster } from "utils";
import { useDuplicateResourceActions, useDuplicateResourceState } from "./DuplicateResourceContext";
import { PaziaModalBlank } from "components/molecules/Modals/PaziaModalBlank";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { PaziaButton } from "components/atoms";

export const ResourceDuplicateModal = () => {
  const { showInfo, showError } = useToaster();
  const { resource, duplicateAction, onSuccess } = useDuplicateResourceState();
  const { clearDuplicateResource } = useDuplicateResourceActions();

  const onConfirm = async () => {
    if (!resource || !duplicateAction) return;
    try {
      const newId = await duplicateAction(resource.id);
      clearDuplicateResource();
      showInfo("Pomyślnie zduplikowano zasób.");
      if (onSuccess) onSuccess(newId);
    } catch (e) {
      showError("Wystąpił błąd podczas duplikowania.");
      console.error(e);
    }
  };

  const onCloseRequest = () => {};
  return (
    <PaziaModalBlank modalOpen={!!resource} onCloseRequest={onCloseRequest} id="duplicate-modal">
      {resource && (
        <ModalPadding>
          <ModalHeader>Duplikowanie zasobu</ModalHeader>
          <p className="pb-10">
            Czy napewno chcesz zduplikować zasób <br />
            <span className="font-semibold">{resource.name}</span>?<br />
            {resource?.description ?? ""}
          </p>

          <div className="flex justify-end gap-2">
            <PaziaButton title="Anuluj" type="tertiary" btnType="button" onClick={onCloseRequest} />
            <PaziaButton type="success" onClick={onConfirm} btnType="button">
              Potwierdź
            </PaziaButton>
          </div>
        </ModalPadding>
      )}
    </PaziaModalBlank>
  );
};
